import { render, staticRenderFns } from "./ManageSection.vue?vue&type=template&id=67152aa7&scoped=true"
import script from "./ManageSection.vue?vue&type=script&lang=js"
export * from "./ManageSection.vue?vue&type=script&lang=js"
import style0 from "./ManageSection.vue?vue&type=style&index=0&id=67152aa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67152aa7",
  null
  
)

export default component.exports